import { CommonModule, ViewportScroller } from '@angular/common';
import { effect, inject, NgModule } from '@angular/core';
import { ConfigModule } from '@core/config-angular';
import { AnalyticsModule } from '@analytics/core';
import { ScrollService } from '@innogy/utils-deprecated';

import { EnvironmentClassesComponent } from './environment-classes/environment-classes.component';
import { ScrollManagerComponent } from './scroll-manager/scroll-manager.component';
import { VisitorIdentificationComponent } from './sitecore-identification/sitecore-identification.component';
import { StableMeasureComponent } from './stable-measure/stable-measure.component';

const exportedComponents = [
  EnvironmentClassesComponent,
  StableMeasureComponent,
  ScrollManagerComponent,
  VisitorIdentificationComponent,
];

@NgModule({
  imports: [ConfigModule, CommonModule, AnalyticsModule],
  declarations: [...exportedComponents],
  exports: [...exportedComponents],
})
export class InitializeModule {
  readonly #scrollService = inject(ScrollService);
  readonly #viewportScroller = inject(ViewportScroller);

  constructor() {
    effect(() => {
      this.#viewportScroller.setOffset([
        0,
        this.#scrollService.verticalScrollOffset(),
      ]);
    });
  }
}
